import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

import { serieVideoFiltersAtom } from '../store/atoms/serieVideoFiltersAtom';
import type { SerieVideoFilters } from '../types/serieVideoFilters';

/**
 * Hook para gerenciar os filtros (server-side) da listagem de Vídeos de uma Série.
 *
 * @returns Filtros atuais e funções para atualizar e resetar.
 */
export function useSerieVideoFilters() {
  const [filters, setFilters] = useAtom(serieVideoFiltersAtom);
  const resetFilters = useResetAtom(serieVideoFiltersAtom);

  const updateFilters = (partial: Partial<SerieVideoFilters>) => {
    setFilters(prev => {
      const resetPage = 'page' in partial ? {} : { page: 1 };
      return { ...prev, ...resetPage, ...partial };
    });
  };

  return { filters, updateFilters, resetFilters } as const;
}
